angular.module('dnecom')
    .controller('TransactionExportModalController', ["$scope", "$uibModalInstance", "$http", "$timeout", "notifications", "storeId", function($scope, $uibModalInstance, $http, $timeout, notifications, storeId) {
        $scope.exportForm = {
            'separator' : 'tab'
        };

        $scope.export = function() {
            var $form = $('<form>', {
                'action': Routing.generate('transaction_export', {
                    'id': storeId
                }),
                'method': 'post'
            });

            angular.forEach($scope.exportForm, buildInput.bind(null, $form, ''));

            $form.appendTo('body').submit();
            $form.remove();

            $scope.closeModal();
        };

        var buildInput = function ($form, path, value, key) {
            if (['project', '$$hashKey', 'isRoot'].indexOf(key) >= 0) {
                return;
            }

            if (typeof(value) == 'object') {
                angular.forEach(value, buildInput.bind(null, $form, getInputName(path, key)));
                return;
            }

            $form.append($('<input>', {
                'name'  : getInputName(path, key),
                'value' : value.toString()
            }));
        };

        var getInputName = function (path, key) {
            return path == '' ? key : path + '[' + key + ']';
        };

        $scope.closeModal = function() {
            $uibModalInstance.dismiss();
        };
    }]);
